<div class="bui-tile-container">
    <div class="bui-tile" [ngStyle]="{'height': tileHeight, 'width': tileWidth, 'margin': tileMargin, 'border': tileBorder, 'padding': tilePadding}">
      <ng-content></ng-content>
    </div>
</div>
